module.exports = __webpack_public_path__ + "static/media/sec1logo2.119dfe7e.svg";